import * as _ from "lodash";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@material-ui/core";

import "./UserSuppliersListDetails.scss";
import { Mode } from "../../../../../shared/constants";
import AccountsSearchField from "../../../common-components/accounts-search-field";
import YeulsTable from "../../../../yeuls-table";

const UserSuppliersListDetails = (props) => {
  const { t, i18n } = useTranslation();
  const { mode, user, suppliers, onUserSupplierChange, userSuppliersChanges } = props;
  const [filterValue, setFilterValue] = useState("");
  const [updateTable, setUpdateTable] = useState(true);
  const suppliersHeaders = useMemo(() => mode === Mode.edit ?
    [".", t("name"), t("supplier-number"), t("business-number")] :
    [t("name"), t("supplier-number"), t("business-number")], [i18n.language, mode]);
  const suppliersColumns = useMemo(() =>
      mode === Mode.edit ?
        "selectedView.supplier_name.santec_account_id.business_number" :
        "supplier_name.santec_account_id.business_number"
    , [mode]);

  const filteredSuppliers = useMemo(() => {
    const filterValueToLowerCase = filterValue?.toLowerCase();
    const userSupplierIds = _.map(user.suppliers, "id");
    const filteredValues = _.filter(suppliers, (supplier) =>
      ( supplier.supplier_name?.toLowerCase() || "" ).indexOf(filterValueToLowerCase) !== -1 ||
      ( supplier.business_number?.toString() || "" ).indexOf(filterValueToLowerCase) !== -1 ||
      ( supplier.santec_account_id?.toString() || "" ).indexOf(filterValueToLowerCase) !== -1);

    return [
      ..._.filter(filteredValues, (value) => _.includes(userSupplierIds, value.id)),
      ..._.filter(filteredValues, (value) => !_.includes(userSupplierIds, value.id)),
    ]
    // eslint-disable-next-line
  }, [suppliers, filterValue, mode]);

  const mappedSuppliers = useMemo(() => {
    const userSupplierIds = _.map(user.suppliers, "id");

    if (!_.values(userSuppliersChanges)?.length) {
      setUpdateTable(false);
      setTimeout(() => setUpdateTable(true));
    }

    return _(filteredSuppliers)
      .filter((supplier) => mode === Mode.edit || _.includes(userSupplierIds, supplier.id))
      .map((supplier) => {
        return {
          ...supplier,
          selectedView: <Checkbox checked={( !!_.find(user.userSuppliers, { supplier_id: supplier.id }) ||
            !!userSuppliersChanges[supplier.id] ) && userSuppliersChanges[supplier.id] !== null}
                                  onChange={(e) => onUserSupplierChange(e.target.checked, supplier.id)}/>,
        }
      })
      .value();
  }, [filteredSuppliers, mode, userSuppliersChanges]);

  return <div className="user-suppliers-details-wrapper">
    {mode === Mode.edit &&
    <AccountsSearchField filterValue={filterValue} setFilterValue={setFilterValue} showSearchMessage={false}/>}
    {updateTable && <YeulsTable
      data={mappedSuppliers}
      headers={suppliersHeaders}
      columns={suppliersColumns}
      totalCount={mappedSuppliers.length}
      perPageItemCount={12}
      partialPageCount={3}
      nextPageText=">"
      prePageText="<"
      className={`agents-table-container ${mode === Mode.edit ? "edit" : "view"}`}
    />}
    {mode === Mode.view && !user.suppliers?.length &&
    <div className="empty-list">{t("user-suppliers-empty-list")}</div>}
  </div>
}

export default UserSuppliersListDetails;